import Slideout from './lib/slideout.min'

document.addEventListener('DOMContentLoaded', function () {
	var scheduleIdleTask = window.requestIdleCallback
		? function (callback) {
				return window.requestIdleCallback(callback, { timeout: 500 })
			}
		: function (callback) {
				return window.setTimeout(callback, 1)
			}
	var scheduleNextPaint = window.requestAnimationFrame
		? function (callback) {
				return window.requestAnimationFrame(callback)
			}
		: function (callback) {
				return window.setTimeout(callback, 16)
			}
	var existingTheme = window.aubuchonTheme || {}

	window.aubuchonTheme = Object.assign({}, existingTheme, {
		scheduleIdleTask: scheduleIdleTask,
		scheduleNextPaint: scheduleNextPaint,
	})

	globalScripts()

	// $body.is('.single') && articlePage()

	function globalScripts() {
		var panel = document.getElementById('panel')
		var menu = document.getElementById('menu')
		var toggleNav = document.getElementById('toggle_nav')

		// init off canvas nav
		if (panel && menu && toggleNav) {
			var slideout = new Slideout({
				panel: panel,
				menu: menu,
				padding: 277,
				tolerance: 70,
				touch: false,
				side: 'right',
			})

			toggleNav.addEventListener('click', function (e) {
				e.preventDefault()
				slideout.toggle()
			})
		}
	}
})
